/**
 * Midlife Trial LP UGC — horizontal carousel nav + video playback.
 */

(function () {
  if (window.__ctrMlTrialLpUgcInitialized) return;
  window.__ctrMlTrialLpUgcInitialized = true;

  const ROOT_SELECTOR = "[data-ctr-ml-trial-lp-ugc]";
  const TRACK_SELECTOR = "[data-ctr-ml-trial-lp-ugc-track]";
  const PREV_SELECTOR = "[data-ctr-ml-trial-lp-ugc-prev]";
  const NEXT_SELECTOR = "[data-ctr-ml-trial-lp-ugc-next]";
  const CARD_SELECTOR = "[data-ctr-ml-trial-lp-ugc-card]";
  const PLAY_SELECTOR = "[data-ctr-ml-trial-lp-ugc-play]";
  const VIDEO_SELECTOR = ".ctr-midlife-trial-lp-ugc__video";
  const PLAYING_CLASS = "is-playing";

  function getScrollStep(track) {
    const slide = track.querySelector(".ctr-midlife-trial-lp-ugc__slide");
    if (!slide) return 0;

    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;

    return slide.getBoundingClientRect().width + gap;
  }

  function updateNavState(root, track) {
    const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
    const prevButtons = root.querySelectorAll(PREV_SELECTOR);
    const nextButtons = root.querySelectorAll(NEXT_SELECTOR);
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft >= maxScrollLeft - 1;

    prevButtons.forEach((button) => {
      button.disabled = atStart;
    });

    nextButtons.forEach((button) => {
      button.disabled = atEnd;
    });
  }

  function pauseVideo(card) {
    const video = card.querySelector(VIDEO_SELECTOR);
    if (video && !video.paused) video.pause();
    card.classList.remove(PLAYING_CLASS);
  }

  function pauseOtherVideos(exceptCard) {
    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      if (card !== exceptCard) pauseVideo(card);
    });
  }

  function hasPlayableSource(video) {
    if (!video) return false;
    if (video.currentSrc || video.src) return true;

    return Boolean(video.querySelector("source[src]"));
  }

  function playCard(card) {
    const video = card.querySelector(VIDEO_SELECTOR);
    if (!hasPlayableSource(video)) return;

    pauseOtherVideos(card);
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {});
    }
  }

  function toggleCard(card) {
    const video = card.querySelector(VIDEO_SELECTOR);
    if (!hasPlayableSource(video)) return;

    if (video.paused) {
      playCard(card);
    } else {
      pauseVideo(card);
    }
  }

  function initVideos(root) {
    root.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      if (card.dataset.ctrMlTrialLpUgcVideoInit === "true") return;
      card.dataset.ctrMlTrialLpUgcVideoInit = "true";

      const video = card.querySelector(VIDEO_SELECTOR);
      const playButton = card.querySelector(PLAY_SELECTOR);
      const media = card.querySelector(".ctr-midlife-trial-lp-ugc__video-media");
      if (!hasPlayableSource(video)) return;

      video.addEventListener("play", () => {
        pauseOtherVideos(card);
        card.classList.add(PLAYING_CLASS);
      });

      video.addEventListener("pause", () => {
        if (video.paused) card.classList.remove(PLAYING_CLASS);
      });

      video.addEventListener("ended", () => {
        card.classList.remove(PLAYING_CLASS);
      });

      if (media) {
        media.addEventListener("click", (event) => {
          if (event.target.closest("[data-ctr-ml-trial-lp-scroll-to-buybox]")) return;
          event.preventDefault();
          toggleCard(card);
        });
      }

      if (playButton) {
        playButton.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          playCard(card);
        });
      }
    });
  }

  function initCarousel(root) {
    const track = root.querySelector(TRACK_SELECTOR);
    if (!track) return;

    const scrollByStep = (direction) => {
      const step = getScrollStep(track);
      if (!step) return;

      track.scrollBy({
        left: direction * step,
        behavior: "smooth",
      });
    };

    root.querySelectorAll(PREV_SELECTOR).forEach((button) => {
      button.addEventListener("click", () => {
        scrollByStep(-1);
      });
    });

    root.querySelectorAll(NEXT_SELECTOR).forEach((button) => {
      button.addEventListener("click", () => {
        scrollByStep(1);
      });
    });

    track.addEventListener("scroll", () => {
      updateNavState(root, track);
    }, { passive: true });

    window.addEventListener("resize", () => {
      updateNavState(root, track);
    });

    updateNavState(root, track);
    initVideos(root);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target.querySelector(ROOT_SELECTOR);
    if (root) initCarousel(root);
  });
})();

